import { WorksPage } from "./Works";
export default WorksPage;
